export const SERVER_URL = '/api';
export const WEBSOCKET_URL = 'wss://www.aixelo.ai/api';
